module.exports = __webpack_public_path__ + "static/media/pickup.af130611.png";